module.exports = __webpack_public_path__ + "img/fix.ac298633.png";